import React, { lazy, Suspense, useEffect, useState } from "react";
import { Image, Row, Col, Container,Navbar  } from "react-bootstrap";
import styles from "../css/banner.module.css";
import jonathan from "../images/jonathan-img.png";
import "../../App.css";
import Twitter_logo_white from "../images/Twitter_logo_white.png"
import parse from 'html-react-parser'


const Banner = ({sunwestLink}) => {

let logoBlue = "https://d2w24n4g34usfg.cloudfront.net/otech/swmc-logo.webp";
let logo = "https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png";

const [navbar, setNavbar] = useState(false)

//logo scroll when active
const [navbarLogo, setNavbarLogo] = useState(logo)

  const changeBackground = () => {
    console.log(window.scrollY)
    if (window.scrollY >= 66) {
      setNavbar(true)
    } else {
      setNavbar(false)
    }
  }

  useEffect(() => {
    changeBackground()
    // adding the event when scroll change background
    window.addEventListener("scroll", changeBackground)
  })

  const changeLogo = () => {
    if (window.scrollY >= 60) {
      setNavbarLogo(logoBlue)
    } else {
      setNavbarLogo(logo)
    }
  }

  useEffect(() => {
    changeLogo()
    // adding the event when scroll change Logo
    window.addEventListener("scroll", changeLogo)
  })

  return (
    <div className={styles["banner-section"]}>
      <Container className={styles["banner-row-container"]}>
{/* 
      <Navbar expand="lg"
            fixed="top"
            bg="dark"
            variant="dark"
            className={navbar ? 'navbar active' : 'navbar'}>
            <div className="mb-3 align-center d-md-logo">
              <a
                href="https://www.swmc.com"
                target="_blank"
                rel="noreferrer noopener"
                className="a-link"
              >
                <img
                  src={"https://resources.swmc.com/swmc-images/txroundup/bluesunwestlogodesktop.webp"}
                  alt="Sun West Mortgage Logo"
                  className="swmclogo img-fluid"
                />
              </a>
            </div>
          </Navbar> */}
        <Row className={styles["banner-row"]}>
          <Col xl={9} lg={10} md={8} sm={12} className={`px-0 ${styles[""]}`}>
            {/* <div className={styles["logo-div"]}>
              <a href="https://www.swmc.com/" target="_self">
                <Image
                  className={styles["swmc-logo"]}
                  src={`${process.env.REACT_APP_CDN}images/logo_mobile.svg`}
                  fluid
                  alt="swmc-logo"
                  width={"400px"}
                  height={"100px"}
                  fetchpriority="high"
                />
              </a>
            </div> */}
          </Col>
        </Row>
        <Row className={styles["info-row"]}>
          <Col
            xl={7}
            lg={8}
            md={8}
            sm={12}
            xs={12}
            className={styles["content-col"]}
          >
            <div className={`${styles["ceo-info"]} text-align-left`}>
              <p>Jonathan Ortiz</p>
              <p>Information Security Manager at </p>
              <p> {parse(sunwestLink)}</p>
            </div>
            {/* <div className={`${styles["ceo-infomobile"]} text-align-left`}>
              <p>Ilena Agarwal</p>
              <p>Chief Executive of Community Lending </p>
             
            
            </div> */}
            <Image
              className={`${styles["circular-stripe"]} ${styles["circular-stripe-blue"]}`}
              src={`${process.env.REACT_APP_CDN}images/circular_stripes_blue.svg`}
              fluid
              alt="circular-stripe blue icon"
              width={"50px"}
              height={"70px"}
            />
          </Col>
          <Col
            xl={5}
            lg={4}
            md={4}
            sm={12}
            xs={12}
            className={styles["ceo-img-col"]}
          >
            <div>
              <div className={styles["SocialIcons"]}>
                <div className={styles["insta"]}>
                  <a
                    href="https://www.swmc.com/ "
                    target="_blank"
                    className={styles["iconPavan"]}
                  >
                    <Image
                      className={`${styles["InstaPavan"]}`}
                      src={`${process.env.REACT_APP_CDN}images/Insta_pavan.png`}
                      fluid
                      alt="jonathan_Instagram"
                      width={"38px"}
                    />
                  </a>
                </div>
                <a
                  href="https://www.swmc.com/"
                  target="_blank"
                  className={styles["iconPavan"]}
                >
                  <Image
                    className={`${styles["YoutubePavan"]}`}
                    src={`${process.env.REACT_APP_CDN}images/youtube_pavan.png`}
                    fluid
                    alt="jonathan_YouTube"
                    width={"38px"}
                  />
                </a>
                <a
                  href="https://www.swmc.com/"
                  target="_blank"
                  className={styles["iconPavan"]}
                >
                  <Image
                    className={`${styles["twitterPavan"]}`}
                    src={Twitter_logo_white}
                    fluid
                    alt="jonathan_Twitter"
                    width={"20px"}
                  />
                </a>
                <a
                  href="https://www.swmc.com/"
                  target="_blank"
                  className={styles["iconPavan"]}
                >
                  <Image
                    className={`${styles["facebookPavan"]}`}
                    src={`${process.env.REACT_APP_CDN}images/facebook_pavan.png`}
                    fluid
                    alt="jonathan_Facebook"
                    width={"38px"}
                  />
                </a>
                <a
                  href="https://www.linkedin.com/in/jortiz5 "
                  target="_blank"
                  className={styles["iconPavan"]}
                >
                  <Image
                    className={`${styles["LinkdnPavan"]}`}
                    src={`${process.env.REACT_APP_CDN}images/linkdn_pavan.png`}
                    fluid
                    alt="jonathan_Linkedin"
                    width={"38px"}
                  />
                </a>
              </div>
              <Image
                className={styles["ceo-img"]}
                src={jonathan}
                fluid
                alt="jonathan image"
                width={"200px"}
                height={"200px"}
                fetchpriority="high"
              />
            </div>
          </Col>
        </Row>
      </Container>
      <div className={styles["banner-img"]} />
      <Image
        className={`${styles["dot-matrix"]} ${styles["dot-matrix-b-1"]}`}
        src={`${process.env.REACT_APP_CDN}images/dot_matrix_2.svg`}
        fluid
        alt="dot-matrix icon"
        width={"50px"}
        height={"70px"}
      />
      <Image
        className={`${styles["dot-matrix"]} ${styles["dot-matrix-b-2"]}`}
        src={`${process.env.REACT_APP_CDN}images/dot_matrix_2.svg`}
        fluid
        alt="dot-matrix icon"
        width={"50px"}
        height={"70px"}
      />
      <Image
        className={`${styles["circular-stripe"]} ${styles["circular-stripe-img-1"]}`}
        src={`${process.env.REACT_APP_CDN}images/circular_stripes.svg`}
        fluid
        alt="circular-stripe icon"
        width={"50px"}
        height={"70px"}
      />
      <Image
        className={`${styles["circular-stripe"]} ${styles["circular-stripe-img-2"]}`}
        src={`${process.env.REACT_APP_CDN}images/circular_stripes.svg`}
        fluid
        alt="circular-stripe icon"
        width={"50px"}
        height={"70px"}
      />
      <Image
        className={`${styles["circular-stripe"]} ${styles["circular-stripe-img-3"]}`}
        src={`${process.env.REACT_APP_CDN}images/circular_stripes.svg`}
        fluid
        alt="circular-stripe icon"
        width={"50px"}
        height={"70px"}
      />
      <Image
        className={`${styles["circular-stripe"]} ${styles["circular-stripe-img-4"]}`}
        src={`${process.env.REACT_APP_CDN}images/circular_stripes.svg`}
        fluid
        alt="circular-stripe icon"
        width={"50px"}
        height={"70px"}
      />
    </div>
  );
};

export default Banner;
